import { render, staticRenderFns } from "./worksCenter.vue?vue&type=template&id=6f87c118&scoped=true&"
import script from "./worksCenter.vue?vue&type=script&lang=js&"
export * from "./worksCenter.vue?vue&type=script&lang=js&"
import style0 from "./worksCenter.vue?vue&type=style&index=0&id=6f87c118&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f87c118",
  null
  
)

export default component.exports